import React from 'react'

const PayoutContent = (props) => {
    const payout = props.payout
    const year = props.year
    const chartAgent = props.chartAgent

    const thousandSeparator = nStr => {
        return nStr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const formatDate = (datetime) => {
        const datetimeValue = new Date(datetime);
        return `${datetimeValue.toLocaleDateString()}`;
    };

    return (
        <>
            <div className='flex md:flex-row flex-col items-center md:gap-5 gap-2 w-full'>
                <div className='border border-border rounded-[10px] h-full md:w-auto w-full flex-1 px-1.5 py-2'>
                    {payout?.typePayout && <div>
                        <canvas id="payoutPieChart"></canvas>
                    </div>}
                </div>

                <div className='border border-border rounded-[10px] h-full md:w-auto w-full flex-[2] px-1.5 py-2'>
                    {payout?.monthlyPayout && <div>
                        <canvas id="monthlyPayoutBarChart"></canvas>
                    </div>}
                </div>
            </div>

            <div className='flex flex-col w-full'>
                <div className='flex gap-5 mb-2'>
                    <div className='w-full flex items-start justify-center text-center'>
                        <p className='text-xs font-semibold text-gray-one'>{ `${ year } Payout Listing - ${ chartAgent?.UserName }` }</p>
                    </div>
                </div>

                <div className='rounded-[10px] border border-border overflow-hidden bg-white flex-1'>
                    <div className='overflow-auto'>
                        <table className="w-full">
                            <thead className="border-b border-border bg-secondary-light text-gray-one">
                                <tr>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">
                                        #
                                    </th>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                        PV Date
                                    </th>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                        Payout Type
                                    </th>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                        Override From
                                    </th>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">
                                        Account
                                    </th>
                                    <th scope="col" className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-right">
                                        Payout Amount(RM)
                                    </th>
                                </tr>
                            </thead >
                            <tbody>
                                {
                                    (payout || payout?.payoutTransactions?.length > 0) ?
                                    payout.payoutTransactions?.map((item, idx) => {
                                        return <tr key={ item._id } className={ 'border-border text-gray-two ' + (idx !== 0 ? 'border-t' : '') }>
                                            <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-center">{`${ idx + 1 }`}</td>
                                            <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                { formatDate(item.CommissionDate) }
                                            </td>
                                            <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                { item.CommissionType }
                                            </td>
                                            <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                { item?.overrideFrom?.UserName ?? '-' }
                                            </td>
                                            <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-left">
                                                { item.CommissionAccount }
                                            </td>
                                            <td className="text-xs font-light px-3 py-2 whitespace-nowrap text-right">
                                                { thousandSeparator(item.CommissionSum) }
                                            </td>
                                        </tr>
                                    }) :
                                    <tr className='text-gray-two'>
                                        <td colSpan='100%' className="text-xs font-light px-3 py-2 whitespace-nowrap text-center">There is no data</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PayoutContent